import container from '@ioc';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IAuthenticationService, PortfoliosServiceClient, ProgressResultDtoOfMultiPortfolioHoldingList } from 'clientportalshared';
import { IAuthenticationService$ } from '@services/auth/IAuthentication.interface';
import ILoggingService, { ILoggingService$ } from '@services/logging/ILoggingService.interface';
import appConfig from '@config/appConfig';
import { getAustralianDate } from '@src/app/utils/GenericUtils';
import { holdingsInitiateThunkPayload, holdingsProgressThunkPayload } from '../../constants';
import { GetHoldingsRequest } from './types';

export const initiateHoldingsAsync = createAsyncThunk<string, GetHoldingsRequest>(holdingsInitiateThunkPayload, async (request) => {
  const authService = container.get<IAuthenticationService>(IAuthenticationService$);
  const loggingService = container.get<ILoggingService>(ILoggingService$);
  const client = new PortfoliosServiceClient(appConfig.apiEndpointUrl, authService, loggingService, appConfig);

  const response = await client.initiateMultiPortfolioHoldingsAsync(getAustralianDate(request.asOfDate), request.clientPortfolios);
  const progressId = response?.progressId;
  if (!progressId) {
    throw new Error('Failed to initiate holdings request.');
  }
  return progressId;
});

export const getHoldingsProgressAsync = createAsyncThunk<ProgressResultDtoOfMultiPortfolioHoldingList, string>(
  holdingsProgressThunkPayload,
  async (progressId) => {
    const authService = container.get<IAuthenticationService>(IAuthenticationService$);
    const loggingService = container.get<ILoggingService>(ILoggingService$);
    const client = new PortfoliosServiceClient(appConfig.apiEndpointUrl, authService, loggingService, appConfig);

    return await client.getMultiPortfolioHoldingsProgressAsync(progressId);
  }
);
